module.exports = __webpack_public_path__ + "img/icon-print-layout-horizontal.cc210365.svg";